module.exports = __webpack_public_path__ + "static/media/robot latinad (1).c4b3116b.png";